import { Button, IconButton, Typography } from '@chr/eds-react';
import { Box, Drawer, Stack, useMediaQuery, useTheme } from '@mui/material';
import { ProgressButton, ProgressButtonProps, } from '../progress-button/ProgressButton';
import { ButtonProps } from '@chr/eds-react/Button/ButtonProps';

export interface SideDrawerProps {
  open: boolean;
  handleClose: (event: object) => void;
  title: string;
  primaryButton?: ProgressButtonProps;
  secondaryButton?: ButtonProps;
  children: React.ReactNode;
}

export const SideDrawer = ({
  open,
  handleClose,
  title,
  primaryButton,
  secondaryButton,
  children,
}: SideDrawerProps) => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      anchor="right"
      sx={{
        '.MuiDrawer-paper': {
          width: isMobileScreen ? '100%' : '380px',
          padding: 3,
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          '.MuiButton-root': {
            color: theme.palette.grey[900],
          },
        }}
      >
        <Typography variant="h3">{title}</Typography>
        <IconButton
          ariaLabel="Close Side Drawer"
          icon="close"
          onClick={handleClose}
          iconVariant="twoToned"
        />
      </Stack>
      <Stack spacing={4}>
        <Box>
          <Box sx={[isMobileScreen && { marginBottom: '140px' }]}>
            {children}
          </Box>
        </Box>
        <Box
          data-testid="ButtonContainer"
          sx={[
            isMobileScreen && {
              position: 'fixed',
              bottom: 0,
              right: 0,
              left: 0,
              padding: 3,
              backgroundColor: theme.palette.background.paper,
              zIndex: 2,
            },
          ]}
        >
          <Stack
            data-testid="ButtonStack"
            direction={isMobileScreen ? 'column-reverse' : 'row'}
            spacing={2}
            justifyContent="space-between"
          >
            {secondaryButton && (
              <Button {...secondaryButton} fullWidth variant="outlined" />
            )}
            {primaryButton && (
              <ProgressButton
                {...primaryButton}
                fullWidth
                variant="contained"
              />
            )}
          </Stack>
        </Box>
      </Stack>
    </Drawer>
  );
};
